import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from './ApplicationsSettings.css';
import { IAChoiceGroup } from './../../../choiceGroup/ChoiceGroup';
import { IAButton } from '../../../button/Button';
import { TreeTargeting } from './../../../treeTargeting/TreeTargeting';
import { TargetingAdminStore } from '../../stores/TargetingAdminStore';
import { Environment } from './../../../../services/Environment';
import { IAToggle } from './../../../toggle/Toggle';
import { IApplication, IDefaultValues, Instance } from './../../../../interfaces/IApplication';
import { TargetingService } from './../../../../services/TargetingService';
import { LocalizationService } from './../../../../services/LocalizationService';
import { IAPanel } from '../../../panels/Panel';
import { IATooltip } from './../../../tooltip/Tooltip';
import { IAIcon } from '../../../icon/Icon';
import { ITargetingExistingStrucuture } from '../../../../interfaces/ITargetingExistingStructure';
import { ContentOrganizerStore } from '../../../contentOrganizerWizard/stores';
import { TreeTargetingForGroups } from '../../../treeTargetingForGroups';

export interface ITargetingSettingsProps {
  targetingStore?: TargetingAdminStore;
  contentOrganizerStore?: ContentOrganizerStore;
  open: boolean;
  close: () => void;
  isApplication: boolean;
  application: IApplication;
  instance: Instance;
  isMountOnMainPanel?: boolean;
  highlightColor?: string;
  style?: React.CSSProperties;
}

export interface ITargetingSettingsState {
  radioValue: string;
  color: string;
  storedValues: Array<{ label: string, id: string, value?: boolean }>;
  allValues: boolean;
  useDefaultValues: boolean;
  enableTargeting: boolean;
  treeValues: Array<{ label: string, id: string, field?: string }>;
  isSaving: boolean;
  required: boolean;
  targetingExistingStructure: ITargetingExistingStrucuture;
  applicationData?: any;
}

@inject('targetingStore')
@observer
export class ApplicationsSettings extends React.Component<ITargetingSettingsProps, ITargetingSettingsState> {
  constructor(props: ITargetingSettingsProps, state: ITargetingSettingsState) {
    super(props, state);

    this.state = {
      radioValue: "profileData",
      color: this.props.highlightColor,
      storedValues: [],
      allValues: false,
      useDefaultValues: false,
      enableTargeting: true,
      treeValues: [],
      isSaving: false,
      required: false,
      targetingExistingStructure: {
        useDefaultStructure: false,
        nodes: []
      }
    };
    if (this.props.targetingStore.language != undefined) {
      this.props.targetingStore.setLanguage(this.props.targetingStore.language);
    }
  }

  public componentWillReceiveProps(nextProps: ITargetingSettingsProps) {
    const treeValues: Array<{ label: string, id: string, field?: string }> = [];
    let required = false;
    let userGroups = [];
    if (nextProps?.application?.name && nextProps?.application?.name !== this.props.application?.name) {
      this.getApplication(nextProps.application.name as "Content Organizer" | "Messages" | "Events" | "Navigator" | "Toolbox" | "App");
    }
    if (nextProps.instance) {
      if (this.props.targetingStore.groupsList && this.props.targetingStore.groupsList.length) {
        userGroups = this.props.targetingStore.groupsList.map((group) => {
          let storedGroup = nextProps.instance.values.find(g => g.id === group.id);
          required = ((storedGroup && storedGroup.value) ? storedGroup.value : required);
          return { label: group.title, id: group.id, value: nextProps.instance.allValues ? true : ((storedGroup && storedGroup.value) ? storedGroup.value : false) };
        });
      }

      if (nextProps.instance.type === "profileData" && nextProps.instance.values) {
        nextProps.instance.values.forEach(value => {
          treeValues.push({ label: value.label, id: value.id, field: value.field });
        });
        if (treeValues.length > 0) {
          required = true;
        }
      }
      let radioValue = nextProps.application.default.type;
      if (nextProps.application.name.toLocaleLowerCase() === 'content organizer') {
        radioValue = nextProps.instance.type;
      }
      if (nextProps.application.name.toLocaleLowerCase() === 'app') {
        radioValue = "profileData";
      }
      this.setState({ radioValue, allValues: nextProps.instance.allValues, enableTargeting: nextProps.instance.isEnable, useDefaultValues: nextProps.instance.useDefault, storedValues: userGroups, treeValues, required });
    } else {
      if (this.props.targetingStore.groupsList && nextProps.application) {
        if (this.props.targetingStore.groupsList && this.props.targetingStore.groupsList.length) {
          userGroups = this.props.targetingStore.groupsList.map((group) => {
            let storedGroup = nextProps.application && nextProps.application.default && nextProps.application.default.values ? nextProps.application.default.values.find(g => g.id === group.id) : undefined;
            required = ((storedGroup && storedGroup.value) ? storedGroup.value : required);
            return { label: group.title, id: group.id, value: nextProps.application.default.allValues ? true : ((storedGroup && storedGroup.value) ? storedGroup.value : false) };
          });
        }
        if (nextProps.application.default.type === "profileData" && nextProps.application.default.values) {
          nextProps.application.default.values.forEach(value => {
            treeValues.push({ label: value.label, id: value.id, field: value.field });
          });
          if (treeValues.length > 0) {
            required = true;
          }
        }

        this.setState({ radioValue: nextProps.application.default.type, allValues: nextProps.application.default.allValues, enableTargeting: nextProps.application.default.isEnable, useDefaultValues: false, storedValues: userGroups, treeValues, required });
      }
    }
  }

  private getSelectedValues(): any[] {
    const selectedValues = [];
    this.state.storedValues?.forEach((item) => {
      if (item.value) {
        selectedValues.push(item.id);
      }
    });
    return selectedValues;
  }

  private getApplication(application: "Content Organizer" | "Messages" | "Events" | "Navigator" | "Toolbox" | "App"): void {
    TargetingService.getApplication(this.props.targetingStore.environment, this.props.targetingStore.tenant, "222", application, true).then((applications) => {
      const applicationData = applications?.value[0];
      let application: IApplication;
      const appData = JSON.parse(applicationData.defaultValues);
      let defaultValues: IDefaultValues;
      if (!appData || Array.isArray(appData)) {
        const list: any[] = [];
        defaultValues = {
          isEnable: false,
          type: "profileData",
          values: list,
          allValues: false
        };
        application = {
          id: undefined,
          title: applicationData.title,
          name: applicationData.title,
          instances: [],
          default: defaultValues
        };
      } else {
        application = appData;
        if (applications && applicationData) {
          application.default.type = applicationData.applicationSettings?.toLocaleLowerCase() === "profile data" ? "profileData" : "userGroups";
        }
      }
      applicationData.application = application;
      applicationData.targetingGroups = this.props.targetingStore.groupsList;
      console.log(this.props.targetingStore.groupsList);
      this.setState({ applicationData });
    });
  }

  public render(): JSX.Element {
    if (!this.props.application) {
      return (<div></div>);
    }
    let panel = (
      <div style={this.props.style} className={styles.IA_viewPanelContentWrapper}>
        <div style={{ marginTop: '10px', marginBottom: '20px', fontWeight: 600, fontSize: '17px' }}>{this.props.isMountOnMainPanel ? "" : !this.props.instance ? this.props.application.name : `${this.props.application.name} - ${this.props.instance.name}`}</div>
        {
          <div>
            <IAToggle
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsEnableTarget}
              checked={this.state.enableTargeting}
              onChange={() => {
                this.setState({ enableTargeting: !this.state.enableTargeting })
              }}
              style={{
                width: "unset"
              }}
              color={this.state.color}
            />
          </div>}
        {this.state.enableTargeting &&
          <div>
            {(!this.props.isApplication && this.props.application.name.toLocaleLowerCase() !== 'content organizer') &&
              <div style={{ marginTop: '10px', marginBottom: 20 }}>
                <IAToggle
                  label={`${new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUseDefault}${this.props.application.name}`}
                  checked={this.state.useDefaultValues}
                  onChange={() => {
                    this.setState({ useDefaultValues: !this.state.useDefaultValues })
                  }}
                  style={{
                    width: "unset"
                  }}
                  color={this.state.color}
                />
              </div>
            }
            {((this.props.isApplication || this.props.application.name.toLocaleLowerCase() === 'content organizer') && this.props.application.name.toLocaleLowerCase() !== 'app') && (!this.props.targetingStore.enableADTargetingComponent || (this.props.targetingStore.enableADTargetingComponent && this.state.radioValue === "profileData")) &&
              <div style={{ marginTop: '10px', marginBottom: '10px', display: 'flex', clear: 'both' }}>
                <IAChoiceGroup
                  label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsSelectTarget}
                  selectedKey={this.state.radioValue}
                  highlightColor={this.state.color}
                  options={[
                    {
                      key: 'userGroups',
                      text: new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUserGroups,
                      disabled: false
                    },
                    {
                      key: 'profileData',
                      text: new LocalizationService().strings.TargetingAdmin_ApplicationSettingsProfileData,
                      disabled: false
                    }
                  ]}
                  required={true}
                  onChange={(key) => {
                    let allValues = true;
                    let required = false;
                    if (key === 'userGroups') {
                      this.state.storedValues.forEach(item => {
                        if (!item.value) {
                          allValues = false;
                        } else {
                          required = true;
                        }
                      });
                    } else {
                      required = this.state.treeValues.length > 0 ? true : false
                      allValues = false;
                    }
                    this.setState({ radioValue: key, allValues, required })
                  }}
                  style={{
                    marginTop: 10
                  }}
                />
                <div style={{ position: 'relative', left: '5px', top: '15px' }}>
                  <IATooltip
                    content="Tooltip"
                    type={"bubble"}
                    styles={{
                      width: 300,
                      color: "#999999",
                      textAlign: "center",
                      marginBottom: "5px"
                    }}
                    componentContent={
                      <div>
                        <ul>
                          <li>{new LocalizationService().strings.TargetingAdmin_ApplicationSettingsInfo}</li>
                        </ul>
                      </div>
                    }>
                    <IAIcon
                      title="Info"
                      size={17}
                      color={this.props.targetingStore.highlightColor}
                      style={{
                        float: "left"
                      }} />
                  </IATooltip>
                </div>
              </div>
            }
            {this.state.applicationData != undefined && (!this.state.useDefaultValues || this.props.isApplication || this.props.application.name.toLocaleLowerCase() === 'content organizer') &&
              <div>
                {this.state.radioValue === 'userGroups' &&
                  <div style={{ clear: 'both', float: "left", marginTop: 20 }}>
                    <TreeTargetingForGroups
                      label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsUserGroupsTarget}
                      required
                      toolTip={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsInfo}
                      applicationData={this.state.applicationData}
                      environment={this.props.targetingStore.environment}
                      tenant={this.props.targetingStore.tenant}
                      application={(this.props.application ? this.props.application.name.toLocaleLowerCase() : this.props.instance.name.toLocaleLowerCase()) as "messages" | "navigator" | "toolbox" | "events" | "content organizer" | "app"}
                      selectedGroupIds={this.getSelectedValues()}
                      showTarget
                      hideOptions
                      highlightColor={this.props.targetingStore.highlightColor}
                      onShowTargetChanged={() => { }}
                      onGroupIdsUpdated={(ids: number[]) => {
                        console.log(ids);
                        let required = false;
                        let list = this.state.storedValues;
                        list.forEach((listItem) => {
                          if (ids.find(id => `${id}` === `${listItem.id}`)) {
                            listItem.value = true;
                          } else {
                            listItem.value = false;
                          }
                        })
                        if (list.filter(x => x.value)) {
                          required = true;
                        }
                        console.log(list);
                        const isAllChecked = !list.find(e => e.value === false);
                        this.setState({
                          storedValues: list,
                          required,
                          allValues: isAllChecked
                        });
                      }}
                    />
                  </div>
                }
                {this.state.radioValue === 'profileData' &&
                  <div style={{ marginBottom: '10px', clear: 'both' }}>
                    <div style={{ marginTop: 10, marginBottom: 10 }}>{new LocalizationService().strings.TargetingAdmin_ApplicationSettingsProfileDataTarget}<span style={{ color: 'red' }}> *</span></div>
                    { /* tslint:disable:no-unused-variable */}
                    <TreeTargeting
                      application={(this.props.application ? this.props.application.name.toLocaleLowerCase() : this.props.instance.name.toLocaleLowerCase()) as "messages" | "navigator" | "toolbox" | "events" | "content organizer" | "app"}
                      tenant={`${this.props.targetingStore.tenant}.sharepoint.com`}
                      authToken={this.props.targetingStore.token}
                      environment={this.props.targetingStore.environment}
                      apiUrl={Environment.getEnvironmentForMainAPI(this.props.targetingStore.environment)}
                      currenNodeStructure={this.state.targetingExistingStructure}
                      selectedValues={this.state.treeValues} //Add stored data
                      showTarget={true}
                      onShowTargetChanged={() => { }}
                      onChange={
                        (targetingDataModel, applicationSettings, groupResult, selectAll, targetingExistingStructure) => {
                          const list: any[] = [];
                          targetingDataModel.forEach(items => {
                            list.push(...items.values);
                          });
                          this.setState({ treeValues: list, allValues: selectAll, required: list.length > 0 ? true : false, targetingExistingStructure: targetingExistingStructure });
                          console.log(applicationSettings, groupResult);
                        }}
                      operator={"AND"}
                      // tslint:disable-next-line: no-empty
                      onLogicalOperatorChanged={() => { }}
                      nodeComparison={"label"}
                      highlightColor={this.state.color}
                      hideOptions={true}
                      selectAll={this.state.allValues}
                      showSelectAll={true}
                      isAdmin={true}
                    />
                  </div>
                }
              </div>}
          </div>
        }
        <div style={{ clear: 'both' }}></div>
        {!this.props.isMountOnMainPanel &&
          <div style={{ marginBottom: '20px', marginTop: '20px', float: "left" }}>
            <IAButton
              style={{ float: 'left' }}
              buttonColor={this.props.targetingStore.highlightColor}
              borderRadius={5}
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsSave}
              disbaled={this.state.isSaving || (this.state.enableTargeting && !this.state.required && !this.state.useDefaultValues)}
              showSpinner={this.state.isSaving}
              onClick={() => {
                this.cleanTargetingExistingStructure();
                let selected = false;
                if (this.state.radioValue === "userGroups") {
                  this.state.storedValues.forEach(item => {
                    if (item.value) {
                      selected = true;
                    }
                  })
                } else {
                  if (this.state.treeValues && this.state.treeValues.length > 0) {
                    selected = true;
                  }
                }
                if (selected || !this.state.enableTargeting || this.state.useDefaultValues) {
                  this.setState({ isSaving: true }, () => {
                    this.save();
                  });
                }
              }}
            />
            <IAButton
              label={new LocalizationService().strings.TargetingAdmin_ApplicationSettingsCancel}
              buttonColor={"#999999"}
              borderRadius={5}
              style={{ marginLeft: "10px", float: 'right' }}
              onClick={() => {
                this.cleanTargetingExistingStructure();
                this.props.close();
              }}
              disbaled={this.state.isSaving}
            />
          </div>
        }

      </div>);

    return (
      <div>
        {!this.props.isMountOnMainPanel &&
          <IAPanel
            showNavigationBar={true}
            itemId={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.id !== undefined ? this.props.targetingStore.userGroupToEdit.id : undefined}
            open={this.props.open}
            transition={this.props.targetingStore.userGroupToEdit != undefined ? "fade" : "slide"}
            width={550}
            isMobile={false}
            tenant={this.props.targetingStore.tenant}
            token={this.props.targetingStore.token}
            environment={this.props.targetingStore.environment}
            disableSaving={this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title === undefined
              || this.props.targetingStore.userGroupToEdit != undefined && this.props.targetingStore.userGroupToEdit.title == ""
            }
            // Actions
            close={() => {
              this.cleanTargetingExistingStructure();
              this.props.close();
            }}
          >{this.props.open ? panel : <></>}</IAPanel>
        }
        {this.props.isMountOnMainPanel &&
          panel
        }
      </div>
    );
  }


  private save() {
    let isEnable = this.state.enableTargeting;
    let allValues = this.state.allValues;
    let type = this.state.radioValue;

    let data: Instance = undefined;
    let application: IApplication = undefined;
    if (!this.props.isApplication) {
      application = this.props.targetingStore.applicationsData.find(x => x.name === this.props.application.name);
      data = application.instances.find(x => x.id === this.props.instance.id);
      data.isEnable = isEnable;
      data.useDefault = (this.props.application.name.toLocaleLowerCase() === 'content organizer') ? false : this.state.useDefaultValues;
      data.allValues = allValues;
      data.values = type === 'userGroups' ? this.state.storedValues.filter(x => x.value) : this.state.treeValues;
      data.type = (this.props.application.name.toLocaleLowerCase() === 'content organizer') ? type : application.default.type

    } else {
      application = this.props.targetingStore.applicationsData.find(x => x.name === this.props.application.name);
      application.default = {
        isEnable,
        type,
        values: type === 'userGroups' ? this.state.storedValues.filter(x => x.value) : this.state.treeValues,
        allValues
      }
    }
    let listObj = {
      id: application.id,
      title: application.title,
      applicationSettings: type === 'userGroups' ? 'User groups' : 'Profile data',
      defaultValues: JSON.stringify(application)
    }

    TargetingService.updateApplicationsTargetSettings(this.props.targetingStore.environment, this.props.targetingStore.tenant, this.props.targetingStore.token,
      listObj, application.id).then(() => {
        this.setState({ storedValues: [], isSaving: false }, () => {
          this.props.close();
        });
      });
  }

  private cleanTargetingExistingStructure = () => {
    this.setState({
      targetingExistingStructure: {
        useDefaultStructure: false,
        nodes: []
      }
    });
  }

}
